import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { BaseService } from '../services/base.service';
import { languages } from '../enum/constants';


@Pipe({
    name: 'dateAgo',
    pure: true,
    standalone: false
})
export class DateAgoPipe implements PipeTransform {
  constructor(private readonly baseService: BaseService) {
  }

  transform(value: any, args?: any): any {
    if (value) {
      const seconds = Math.floor((+new Date() - +new Date(value)) / 1000);
      if (seconds < 29)
        return languages[this.baseService.currentUserInfo.settings.language]['just_now'];
      else {
        moment.locale(`${this.baseService.currentUserInfo.settings.language === 'ua' ? 'uk' : this.baseService.currentUserInfo.settings.language}`);
        return moment(value).fromNow();
      }
    }

    return value;
  }
}
